<span>{{currentText}}</span>
